export default "__VITE_ASSET__nZ6_LDGP__"